/* Trillobeat Motion FX v7.3 - stable repeating desktop banner sweeps */
(function(){
var root=document.documentElement;if(!root.classList.contains('tb-motion'))return;if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
var canHover=matchMedia('(hover: hover) and (pointer: fine)').matches,lastX=-9999,lastY=-9999,isMobileScroll=0,scrollTimer=0;
if(canHover)document.addEventListener('mousemove',function(e){lastX=e.clientX;lastY=e.clientY},{passive:true});
function hideDuringScroll(){if(canHover)return;isMobileScroll=1;root.classList.add('tb-touch-scrolling');document.querySelectorAll('.tb-holo-abs.tb-on').forEach(function(el){el.classList.remove('tb-on')});clearTimeout(scrollTimer);scrollTimer=setTimeout(function(){isMobileScroll=0;root.classList.remove('tb-touch-scrolling');window.dispatchEvent(new CustomEvent('tb:holo-scroll-stop'))},260)}
if(!canHover){window.addEventListener('touchstart',hideDuringScroll,{passive:true});window.addEventListener('touchmove',hideDuringScroll,{passive:true});window.addEventListener('scroll',hideDuringScroll,{passive:true})}
function vars(el,x,y,rx,ry){el.style.setProperty('--tb-x',x+'px');el.style.setProperty('--tb-y',y+'px');el.style.setProperty('--tb-rx',rx+'px');el.style.setProperty('--tb-ry',ry+'px')}
function ease(p){return-(Math.cos(Math.PI*p)-1)/2}
function sweep(o){var start=null,stop=0,faded=0;function tick(t){if(stop)return;if(start===null){start=t;o.start&&o.start()}var p=(t-start)/o.ms;if(p>=1){o.end&&o.end();return}o.frame(p);if(!faded&&p>.86){faded=1;o.fade&&o.fade()}requestAnimationFrame(tick)}requestAnimationFrame(tick);return{cancel:function(){stop=1}}}
function band(set,w,h,p){var b=Math.max(180,Math.min(390,h*.38));if(canHover)b=Math.min(450,b*1.15);set(w/2,-b+ease(p)*(h+2*b),w*.98,b)}
function cursor(el,apply,on,off,rad){var over=0,raf=0,cx=0,cy=0,first=1;function loop(){if(!over){raf=0;return}var r=el.getBoundingClientRect(),tx=lastX-r.left,ty=lastY-r.top;if(first){cx=tx;cy=ty;first=0}cx+=(tx-cx)*.14;cy+=(ty-cy)*.14;apply(cx,cy,rad,rad);raf=requestAnimationFrame(loop)}el.addEventListener('mouseenter',function(){over=1;first=1;on();if(!raf)raf=requestAnimationFrame(loop)});el.addEventListener('mouseleave',function(){over=0;off()})}
function settle(fn){requestAnimationFrame(function(){fn();requestAnimationFrame(fn)})}
function isClipper(el){if(!el||el===document.body||el===document.documentElement)return false;var cs=getComputedStyle(el);var ox=cs.overflowX,oy=cs.overflowY;return /(auto|scroll|hidden|clip)/.test(ox+oy)||el.scrollWidth>el.clientWidth+4}
function inHorizontalCarousel(img){var el=img.parentElement;while(el&&el!==document.body){var cls=(el.className||'').toString();var horizontal=el.scrollWidth>el.clientWidth+8;var named=/(carousel|slider|scroll|gallery|multi-column|media-grid|image-list)/i.test(cls);var cs=getComputedStyle(el);var scrollish=/(auto|scroll|hidden|clip)/.test(cs.overflowX);if(horizontal&&(named||scrollish))return true;el=el.parentElement}return false}
function clipRectFor(img){var r=img.getBoundingClientRect();var clip={left:0,top:-99999,right:innerWidth,bottom:99999};var el=img.parentElement;while(el&&el!==document.body){if(isClipper(el)){var cr=el.getBoundingClientRect();clip.left=Math.max(clip.left,cr.left);clip.right=Math.min(clip.right,cr.right);clip.top=Math.max(clip.top,cr.top);clip.bottom=Math.min(clip.bottom,cr.bottom)}el=el.parentElement}var left=Math.max(r.left+2,clip.left+2,0);var top=Math.max(r.top+2,clip.top+2);var right=Math.min(r.right-2,clip.right-2,innerWidth);var bottom=Math.min(r.bottom-2,clip.bottom-2);return{left:left,top:top,width:Math.max(0,right-left),height:Math.max(0,bottom-top),originLeft:r.left+2,originTop:r.top+2,raw:r}}
function isInView(img){var r=img.getBoundingClientRect();var vh=innerHeight||document.documentElement.clientHeight;return r.width>0&&r.height>0&&r.bottom>vh*.12&&r.top<vh*.88}

function setupPageImages(){
 var section=document.querySelector('.shopify-section--main-page');if(!section)return;
 var h1=section.querySelector('.section-header h1');
 if(h1&&!h1.dataset.tbWords){h1.dataset.tbWords='1';var ws=h1.textContent.trim().split(/\s+/);h1.textContent='';ws.forEach(function(w,i){var s=document.createElement('span');s.className='tb-word';s.textContent=w;s.style.animationDelay=(.16+i*.085)+'s';h1.appendChild(s);if(i<ws.length-1)h1.appendChild(document.createTextNode(' '))})}
 var prose=section.querySelector('.prose');
 if(prose&&'IntersectionObserver'in window){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('tb-inview');io.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px',threshold:.08});Array.prototype.forEach.call(prose.children,function(el){io.observe(el)});Array.prototype.forEach.call(prose.querySelectorAll('img'),function(img){var po=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){po.unobserve(e.target);attachPhoto(e.target)}})},{rootMargin:'300px 0px'});po.observe(img)})}else if(prose){Array.prototype.forEach.call(prose.children,function(el){el.classList.add('tb-inview')})}
}
function attachPhoto(img){
 if(!img||img.dataset.tbHoloAttached||inHorizontalCarousel(img))return;img.dataset.tbHoloAttached='1';
 var overlay=document.createElement('div'),clone=document.createElement('img'),ready=0,current=null,visible=false,playedAt=0,hovered=0;
 overlay.className='tb-holo-abs';overlay.setAttribute('aria-hidden','true');overlay.appendChild(clone);document.body.appendChild(overlay);
 function src(){if(ready)return;var s=img.currentSrc||img.src;if(!s)return;if(img.srcset)clone.srcset=img.srcset;if(img.sizes)clone.sizes=img.sizes;clone.src=s;ready=1}
 function place(){var c=clipRectFor(img);overlay.style.top=c.top+'px';overlay.style.left=c.left+'px';overlay.style.width=c.width+'px';overlay.style.height=c.height+'px';overlay.style.borderRadius=getComputedStyle(img).borderRadius;clone.style.width=c.raw.width+'px';clone.style.height=c.raw.height+'px';clone.style.transform='translate('+(c.originLeft-c.left)+'px,'+(c.originTop-c.top)+'px)';return c}
 function refresh(){settle(place)}
 function stopCurrent(){if(current){current.cancel();current=null}overlay.classList.remove('tb-on')}
 function tryStart(force){if(current||hovered||isMobileScroll||!visible||!isInView(img))return;if(!force&&Date.now()-playedAt<900)return;src();refresh();playedAt=Date.now();current=sweep({ms:4300,start:function(){if(isMobileScroll){overlay.classList.remove('tb-on');return}refresh();overlay.classList.add('tb-on')},fade:function(){overlay.classList.remove('tb-on')},end:function(){overlay.classList.remove('tb-on');current=null;refresh()},frame:function(p){if(isMobileScroll){overlay.classList.remove('tb-on');return}var c=place();band(function(x,y,rx,ry){vars(overlay,x,y,rx,ry)},c.width,c.height,p)}})}
 place();if(!img.complete)img.addEventListener('load',refresh);window.addEventListener('resize',refresh,{passive:true});window.addEventListener('orientationchange',refresh,{passive:true});window.addEventListener('tb:holo-scroll-stop',function(){refresh();tryStart(true)});if(window.visualViewport){visualViewport.addEventListener('resize',refresh,{passive:true})}setTimeout(refresh,250);setTimeout(refresh,800);setTimeout(refresh,1500);
 if(canHover){cursor(img,function(x,y,rx,ry){var c=place();vars(overlay,Math.min(Math.max(x+(c.originLeft-c.left),0),c.width),Math.min(Math.max(y+(c.originTop-c.top),0),c.height),rx,ry)},function(){hovered=1;stopCurrent();src();refresh();overlay.classList.add('tb-on')},function(){hovered=0;overlay.classList.remove('tb-on');tryStart(false)},190)}
 var obs=new IntersectionObserver(function(entries){entries.forEach(function(e){visible=e.isIntersecting;if(visible){tryStart(false)}else{stopCurrent();refresh()}})},{threshold:.5});obs.observe(img);if(canHover){visible=isInView(img);tryStart(false)}
}

function clonePicture(box){
 var pic=box&&box.querySelector('picture:not(.tb-holo-clone):not(.tb-holo-cursor-clone)');if(!pic)return null;
 var auto=box.querySelector('.tb-holo-clone');
 if(!auto){auto=pic.cloneNode(true);auto.className='tb-holo-clone';auto.setAttribute('aria-hidden','true');var autoImg=auto.querySelector('img');if(autoImg){autoImg.removeAttribute('id');autoImg.removeAttribute('fetchpriority');autoImg.setAttribute('loading','lazy')}pic.parentNode.insertBefore(auto,pic.nextSibling)}
 var pointer=box.querySelector('.tb-holo-cursor-clone');
 if(!pointer){pointer=pic.cloneNode(true);pointer.className='tb-holo-cursor-clone';pointer.setAttribute('aria-hidden','true');var pointerImg=pointer.querySelector('img');if(pointerImg){pointerImg.removeAttribute('id');pointerImg.removeAttribute('fetchpriority');pointerImg.setAttribute('loading','lazy')}pic.parentNode.insertBefore(pointer,auto.nextSibling)}
 return auto
}
function setupBox(box,kind){
 if(!box)return;if(!clonePicture(box)&&!box.querySelector('.tb-holo-clone'))return;
 var current=null,restartTimer=0,cursorLayer=box.querySelector('.tb-holo-cursor-clone');
 if(canHover&&cursorLayer){cursor(box,function(x,y,rx,ry){vars(cursorLayer,x,y,rx,ry)},function(){box.classList.add('tb-holo-cursor-active')},function(){box.classList.remove('tb-holo-cursor-active')},kind==='hero'?235:Math.round(Math.min(250,Math.max(135,box.clientWidth*.13))))}
 function clearRestart(){clearTimeout(restartTimer);restartTimer=0}
 function schedule(delay){clearRestart();restartTimer=setTimeout(function(){restartTimer=0;start()},delay==null?140:delay)}
 function start(){clearRestart();if(current||isMobileScroll)return;current=sweep({ms:kind==='hero'?4200:4800,start:function(){if(!isMobileScroll)box.classList.add('tb-holo-active')},fade:function(){box.classList.remove('tb-holo-active')},end:function(){box.classList.remove('tb-holo-active');current=null;if(canHover)schedule(1500)},frame:function(p){if(isMobileScroll){box.classList.remove('tb-holo-active');return}band(function(x,y,rx,ry){vars(box,x,y,rx,ry)},box.clientWidth,box.clientHeight,p)}})}
 function stop(){clearRestart();if(current){current.cancel();current=null}box.classList.remove('tb-holo-active')}
 if(canHover){schedule(40)}else if('IntersectionObserver'in window){new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting)start();else stop()})},{threshold:kind==='hero'?.2:.35}).observe(box)}else start()
}
function setupHero(){
 var hero=document.querySelector('.shopify-section--slideshow slideshow-carousel.slideshow');if(!hero)return;
 var slides=hero.querySelectorAll('.slideshow__slide'),made=0;
 slides.forEach(function(slide){var box=slide.querySelector('.content-over-media');if(box&&clonePicture(box))made++});
 if(!made)return;
 var current=null,currentSlide=null,visible=true,startTimer=0,hovered=0,bandOn=0,HERO_PAUSE_MS=1500;
 function sync(){hero.classList.toggle('tb-holo-active',!!bandOn);hero.classList.toggle('tb-holo-cursor-active',!!hovered)}
 function stop(){clearTimeout(startTimer);startTimer=0;if(current){current.cancel();current=null}bandOn=0;sync()}
 function selected(){return hero.querySelector('.slideshow__slide.is-selected')}
 function start(force){
   if(!visible||isMobileScroll)return;
   var slide=selected();if(!slide)return;
   if(!force&&slide===currentSlide&&current)return;
   stop();currentSlide=slide;
   current=sweep({ms:4200,
     start:function(){if(!isMobileScroll){bandOn=1;sync()}},
     fade:function(){bandOn=0;sync()},
     end:function(){bandOn=0;sync();current=null;if(canHover&&visible&&!isMobileScroll)schedule(true,HERO_PAUSE_MS)},
     frame:function(p){if(isMobileScroll)return;band(function(x,y,rx,ry){vars(hero,x,y,rx,ry)},hero.clientWidth,hero.clientHeight,p)}
   })
 }
 function schedule(force,delay){clearTimeout(startTimer);startTimer=setTimeout(function(){startTimer=0;start(!!force)},delay==null?140:delay)}
 if(canHover){
   cursor(hero,function(x,y,rx,ry){var slide=selected();var layer=slide&&slide.querySelector('.tb-holo-cursor-clone');if(layer)vars(layer,x,y,rx,ry)},function(){hovered=1;sync()},function(){hovered=0;sync()},235)
 }
 if('MutationObserver'in window){
   new MutationObserver(function(){var slide=selected();if(slide&&slide!==currentSlide)schedule(false,180)}).observe(hero,{subtree:true,attributes:true,attributeFilter:['class']})
 }
 if('IntersectionObserver'in window){
   new IntersectionObserver(function(es){es.forEach(function(e){visible=e.isIntersecting;if(visible){if(!current)schedule(false,40)}else stop()})},{threshold:.2}).observe(hero)
 }
 window.addEventListener('tb:holo-scroll-stop',function(){schedule(true,80)});
 schedule(false,40)
}
function setupCollectionBanner(){setupBox(document.querySelector('.shopify-section--collection-banner .content-over-media'),'collection')}
function init(){setupHero();setupCollectionBanner()}
if(document.readyState==='complete')init();else window.addEventListener('load',init);
})();


/* Trillobeat sequential content-page wave v1
   Our Story / Our Process only. One visible target at a time:
   heading -> photo -> next heading -> photo. */
(function () {
  var root = document.documentElement;
  if (!root.classList.contains('tb-wave-full')) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var canHover = matchMedia('(hover: hover) and (pointer: fine)').matches;
  var targets = [];
  var cycleTargets = [];
  var cycleStart = null;
  var pausedUntil = 0;
  var TARGET_MS = 3100;
  var PAUSE_MS = 1100;

  function ease(p) { return -(Math.cos(Math.PI * p) - 1) / 2; }
  function mask(el, x, y, rx, ry) {
    el.style.setProperty('--tb-x', x + 'px');
    el.style.setProperty('--tb-y', y + 'px');
    el.style.setProperty('--tb-rx', rx + 'px');
    el.style.setProperty('--tb-ry', ry + 'px');
  }
  function visible(el) {
    var r = el.getBoundingClientRect();
    var vh = innerHeight || root.clientHeight;
    return r.width > 0 && r.height > 0 && r.bottom > -40 && r.top < vh + 40;
  }
  function inHorizontalCarousel(el) {
    var p = el.parentElement;
    while (p && p !== document.body) {
      var cls = (p.className || '').toString();
      var horizontal = p.scrollWidth > p.clientWidth + 8;
      if (horizontal && /(carousel|slider|gallery|multi-column|media-grid|image-list)/i.test(cls)) return true;
      p = p.parentElement;
    }
    return false;
  }
  function bandY(height, p) {
    var b = Math.max(180, Math.min(390, height * .38));
    if (canHover) b = Math.min(450, b * 1.15);
    return { b: b, y: -b + ease(p) * (height + 2 * b) };
  }

  function registerHeading(h) {
    if (!h || h.dataset.tbSequentialHeading) return;
    h.dataset.tbSequentialHeading = '1';
    var overlay = document.createElement('div');
    overlay.className = 'tb-holo-text';
    overlay.setAttribute('aria-hidden', 'true');
    document.body.appendChild(overlay);

    function syncStyle() {
      var cs = getComputedStyle(h);
      overlay.style.font = cs.font;
      overlay.style.letterSpacing = cs.letterSpacing;
      overlay.style.wordSpacing = cs.wordSpacing;
      overlay.style.textTransform = cs.textTransform;
      overlay.style.textAlign = cs.textAlign;
      overlay.style.padding = cs.padding;
      overlay.style.boxSizing = cs.boxSizing;
      overlay.textContent = h.textContent;
    }
    function place() {
      var r = h.getBoundingClientRect();
      overlay.style.top = r.top + 'px';
      overlay.style.left = r.left + 'px';
      overlay.style.width = r.width + 'px';
      overlay.style.height = r.height + 'px';
      return r;
    }
    syncStyle();
    addEventListener('resize', syncStyle, { passive: true });

    targets.push({
      el: h,
      off: function () { overlay.classList.remove('tb-on'); },
      band: function (p) {
        var r = place();
        var v = bandY(r.height, p);
        overlay.classList.add('tb-on');
        mask(overlay, r.width / 2, v.y, r.width * .9, v.b);
      }
    });
  }

  function registerPhoto(img) {
    if (!img || img.dataset.tbSequentialPhoto || inHorizontalCarousel(img)) return;
    img.dataset.tbSequentialPhoto = '1';
    var overlay = document.createElement('div');
    var clone = document.createElement('img');
    var loaded = 0, hovered = 0, bandOn = 0;
    overlay.className = 'tb-holo-abs';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.appendChild(clone);
    document.body.appendChild(overlay);

    function source() {
      if (loaded) return;
      var s = img.currentSrc || img.src;
      if (!s) return;
      if (img.srcset) clone.srcset = img.srcset;
      if (img.sizes) clone.sizes = img.sizes;
      clone.src = s;
      loaded = 1;
    }
    function place() {
      var r = img.getBoundingClientRect();
      var left = Math.max(0, r.left + 2);
      var right = Math.min(innerWidth, r.right - 2);
      var top = r.top + 2;
      var bottom = r.bottom - 2;
      var p = img.parentElement;
      while (p && p !== document.body) {
        var cs = getComputedStyle(p);
        if (/(hidden|clip|auto|scroll)/.test(cs.overflowX + cs.overflowY)) {
          var pr = p.getBoundingClientRect();
          left = Math.max(left, pr.left + 2);
          right = Math.min(right, pr.right - 2);
          top = Math.max(top, pr.top + 2);
          bottom = Math.min(bottom, pr.bottom - 2);
        }
        p = p.parentElement;
      }
      overlay.style.left = left + 'px';
      overlay.style.top = top + 'px';
      overlay.style.width = Math.max(0, right - left) + 'px';
      overlay.style.height = Math.max(0, bottom - top) + 'px';
      overlay.style.borderRadius = getComputedStyle(img).borderRadius;
      clone.style.width = r.width + 'px';
      clone.style.height = r.height + 'px';
      clone.style.transform = 'translate(' + (r.left + 2 - left) + 'px,' + (r.top + 2 - top) + 'px)';
      return { rect: r, width: Math.max(0, right - left), height: Math.max(0, bottom - top) };
    }
    function sync() {
      overlay.classList.toggle('tb-on', bandOn || hovered);
    }

    if (canHover) {
      var over = 0, raf = 0, cx = 0, cy = 0;
      function cursorLoop() {
        if (!over) { raf = 0; return; }
        var c = place();
        cx += ((window.tbHoloMouseX || c.rect.left + c.rect.width / 2) - c.rect.left - cx) * .14;
        cy += ((window.tbHoloMouseY || c.rect.top + c.rect.height / 2) - c.rect.top - cy) * .14;
        mask(overlay, cx, cy, 190, 190);
        raf = requestAnimationFrame(cursorLoop);
      }
      img.addEventListener('mouseenter', function (e) {
        window.tbHoloMouseX = e.clientX; window.tbHoloMouseY = e.clientY;
        hovered = 1; source(); place(); sync(); over = 1;
        if (!raf) raf = requestAnimationFrame(cursorLoop);
      });
      img.addEventListener('mousemove', function (e) {
        window.tbHoloMouseX = e.clientX; window.tbHoloMouseY = e.clientY;
      }, { passive: true });
      img.addEventListener('mouseleave', function () {
        over = 0; hovered = 0; sync();
      });
    }

    targets.push({
      el: img,
      photo: 1,
      off: function () { bandOn = 0; sync(); },
      band: function (p) {
        if (hovered) return;
        source();
        var c = place();
        var v = bandY(c.height, p);
        bandOn = 1;
        mask(overlay, c.width / 2, v.y, c.width * .98, v.b);
        sync();
      }
    });
  }

  function mergePairedPhotos(prose) {
    var photos = targets.filter(function (t) { return t.photo; });
    var consumed = [];
    var groups = [];

    photos.forEach(function (target) {
      if (consumed.indexOf(target) !== -1) return;
      var p = target.el.parentElement;
      var group = null;
      var depth = 0;
      while (p && p !== prose && depth < 4) {
        var count = p.querySelectorAll('img').length;
        if (count === 2) { group = p; break; }
        if (count > 2) break;
        p = p.parentElement;
        depth++;
      }
      if (!group) return;

      var members = photos.filter(function (candidate) {
        return group.contains(candidate.el);
      });
      if (members.length !== 2) return;

      members.forEach(function (member) {
        if (consumed.indexOf(member) === -1) consumed.push(member);
      });
      groups.push({
        el: group,
        pairedPhotos: 1,
        off: function () {
          members.forEach(function (member) { member.off(); });
        },
        band: function (progress) {
          members.forEach(function (member) { member.band(progress); });
        }
      });
    });

    if (consumed.length) {
      targets = targets.filter(function (target) {
        return consumed.indexOf(target) === -1;
      }).concat(groups);
    }
  }

  function rebuildCycle() {
    cycleTargets = targets.filter(function (t) { return visible(t.el); });
    cycleTargets.sort(function (a, b) {
      return a.el.getBoundingClientRect().top - b.el.getBoundingClientRect().top;
    });
  }
  function turnOffExcept(active) {
    targets.forEach(function (t) { if (t !== active) t.off(); });
  }
  function conductor(ts) {
    requestAnimationFrame(conductor);
    if (document.hidden || root.classList.contains('tb-touch-scrolling')) {
      cycleStart = null;
      turnOffExcept(null);
      return;
    }
    if (ts < pausedUntil) return;
    if (cycleStart === null) {
      rebuildCycle();
      if (!cycleTargets.length) return;
      cycleStart = ts;
    }
    var total = cycleTargets.length * TARGET_MS;
    var elapsed = ts - cycleStart;
    if (elapsed >= total) {
      turnOffExcept(null);
      cycleStart = null;
      pausedUntil = ts + PAUSE_MS;
      return;
    }
    var index = Math.floor(elapsed / TARGET_MS);
    var local = (elapsed - index * TARGET_MS) / TARGET_MS;
    var active = cycleTargets[index];
    turnOffExcept(active);
    if (active) active.band(local);
  }

  function init() {
    var section = document.querySelector('.shopify-section--main-page');
    if (!section) return;
    var h1 = section.querySelector('.section-header h1');
    var prose = section.querySelector('.prose');
    if (h1) registerHeading(h1);
    if (prose) {
      Array.prototype.forEach.call(prose.querySelectorAll('h2, h3'), registerHeading);
      Array.prototype.forEach.call(prose.querySelectorAll('img'), registerPhoto);
      mergePairedPhotos(prose);
    }
    addEventListener('tb:holo-scroll-stop', function () {
      cycleStart = null; pausedUntil = 0; turnOffExcept(null);
    });
    addEventListener('resize', function () {
      cycleStart = null; pausedUntil = 0;
    }, { passive: true });
    requestAnimationFrame(conductor);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
